module.exports = __webpack_public_path__ + "img/KY.c10ca3bf.png";